// extracted by mini-css-extract-plugin
module.exports = {"select":"measurements_select__3KjKI"};